import "../../container/styles.css";

const HomeDancePicFragment = ({
  onClick,
  hideOptions = false,
  imgStyle = null,
  contStyle = null,
  img,
}: {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  hideOptions?: boolean;
  imgStyle?: any;
  contStyle?: any;
  img?: any;
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex flex-col flex-1 home-frag-cont relative ${
        !hideOptions && `mr-3`
      }
      ${contStyle && contStyle}
      `}
    >
      <img
        alt=""
        className={`home-frag-img ${imgStyle}`}
        src={img || require("../../assets/danceFrag.png")}
      />
    </div>
  );
};

export default HomeDancePicFragment;
